import React, { FC } from 'react';
import { AllieIconProps } from '../../..';

export const PlainCheck: FC<AllieIconProps> = ({ color: allieColor, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      style={style}
    >
      <path
        d="M17 1L6 12L1 7"
        stroke={allieColor ?? 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
